import localeAntd from 'ant-design-vue/lib/locale-provider/en_US';

const messages = {
  topBar: {
    profileMenu: {
      hello: 'Hello',
      editProfile: 'Edit Profile',
      settings: 'Settings',
      logout: 'Logout',
    },
  },
  menuLeft: {
    top: {
      churchDashboard: 'Church Dashboard',
    },
    user: {
      churchPartner: 'Church Partner',
      evangelismPartner: 'Evangelism Partner',
    },
    menu: {
      account: 'Account',
      dashboard: 'Dashboard',
      profile: 'Profile',
      viewProfile: 'View Profile',
      editProfile: 'Edit Profile',
      profileVideo: 'Video',
      orderCards: 'Order Invitation Cards',
      evangelismBootcamp: 'Evangelism Boot Camp',
      shareStory: 'Share My Jesus Story',
      messages: 'Messages',
      trackProgress: 'Track Your Progress',
      studyGuides: 'Study Guides',
      bulletinInsert: 'Bulletin Inserts',
      resources: 'Resources',
      monthlyVideos: 'Monthly Videos',
      videoPlayer: 'Video Player',
      campuses: 'Church Finder Address',
      AccountInvoicePayment: 'Account Invoices, Payments, Manage Subscription',
      updateBillingInfo: 'Payment Information',
      paymentInfo: 'Payment Information',
      supportCenter: 'Support Center',
      churchProfile: 'Church Profile',
      churchAccess: 'Church Access',
      testimonials: 'Testimonials',
      welcomeVideo: 'Invitation video',
    },
  },
  pricing: {
    getPricing: 'GET PRICING',
    title: 'To see pricing and join, select your church’s average attendance',
    buttonSelectAbove: 'SELECT ABOVE',
    monthlyPlan: 'Monthly Plan',
    monthlyPlanSub: '(12 Payments Required)',
    buttonJoinMonthly: 'Join Monthly Plan',
    yearlyPlan: 'Yearly Plan',
    yearlyPlanSub: '(save 16%)',
    buttonJoinYearly: 'Join Yearly plan',
    multipleDesign3: 'Three',
    multipleDesign2: 'Two',
    multipleDesign1: 'One',
    errorCard: {
      title: 'The following fields appear to be invalid:',
      number: 'card number',
      month: 'month',
      year: 'year',
      first_name: 'first name',
      last_name: 'last nam',
    },
    feature: {
      para0: {
        title: '—- custom designed QR code pastor video invitation cards',
        content: 'Custom designed QR code pastor video invitation cards',
      },
      para1: {
        title: 'One Year License to use TrueLife.org',
        content: 'One Year License to use TrueLife.org',
      },
      para2: {
        title: 'Majority of Church Inviting & Evangelizing',
        content: 'Majority of Church Inviting & Evangelizing',
      },
      para3: {
        title: 'Access to True Life Church Locator System',
        content: 'Access to True Life Church Locator System',
      },
      para4: {
        title: 'Connect Jesus Stories to Church Profile',
        content: 'Connect Jesus Stories to Church Profile',
      },
      para5: {
        title: 'Study Guides and Leader Guides',
        content: 'Study Guides and Leader Guides',
      },
      para6: {
        title: 'Evangelism Boot Camp and Leader Guides',
        content: 'Evangelism Boot Camp and Leader Guides',
      },
      para7: {
        title: 'Video Player for Your Website',
        content: 'Video Player for Your Website',
      },
    },
    guarantees: {
      para1: 'Above and Beyond Guarantees',
      para2: 'If there is EVER a TrueLife.org video or article the church disagrees with, you get a full refund.',
      para3: 'If your leadership says no after watching the introduction video and before we design your invitation cards and print them, you get a full refund.',
      para4: 'You have 30 days with the cards to follow our strategy. If you are unhappy with the result, we will give you a full refund',
    },
  },
  page: {
    dashboardIndividual: {
      introduction: 'We are excited to help you share your Jesus Story!<br/>Start off by watching the introduction video!',
    },
    dashboard: {
      getMostFromTruelife: {
        para1: 'Example Verbiage for End of the Service to Get Them to Pray Over Their Cards',
        para2:
          'Brothers and sisters, today you have heard the message and the Gospel. There are three invitation cards in front of you that represent three people that have not had that opportunity. Please take these cards. I want us to pray that God will give us the right three people to hand the cards to this week. You might be wondering who they are, so let me tell you. I believe God wants you to hand an invitation card out to anyone that hands you something this week. The drive throughs, the bank, the waiter. Now if you will please, join me in a quiet moment of prayer asking God to bless us with these three people to hand the cards to this week.',
        para3:
          '*Please never work so hard on your sermon and not close your message without saying something like this.  In the future, if you feel like you are losing traction its time to preach a sermon on Hell and our desperate need to reach people before they go there.',
      },
      churchTraningVideo: {
        para1: 'Click To Download The Introduction Video',
      },
      videoShareWithChuch: {
        para1: 'Click To Download The Introduction Video',
      },
      getWeeklyResults: {
        para1: 'Learn how to get results every week in this 2 minute video.',
      },
      accountPaymentDate: {
        para1: 'Yearly Account Renewal Date',
      },
      recentUpdate: {
        para1: 'We have updated our terms of service and privacy policy recently. To view it please click',
        link: 'here',
      },
      whyYouShouldUpgrade: {
        para1: 'Click To Upgrade',
      },
    },
    orderCards: {
      instructionsResources: {
        para1: 'Fill out the form on this page to order your invitation cards from TrueLife.org. We recommend using a desktop computer to place the order, although the form is mobile friendly.',
      },
      reOrderingInstructions: {
        para1: 'If you need to place a re-order for cards please use our re-ordering form.',
        link: 'Click Here',
      },
    },
    trackProgress: {
      submitTrackYourProgress: {
        para1: 'Fill out the form on this page to track your progress from our customer service team.',
      },
    },
    bulletinInserts: {
      bulletinInserts: {
        para1: 'Download pre-designed inserts for your bulletin.',
        link: 'Bulletin Insert Kit',
        para2: 'Included in the kit',
      },
    },
    videoPlayer: {
      videoPlayerForYourChurchWebsite: {
        para1: 'Step One: Enter your church website url (example: www.mychurch.com)',
        para2: 'Step Two: Choose categories to include in the player (Or just click Generate Embed Code to include all categories)',
        para3: 'Add A Give Button: Enter your donation page url',
      },
    },
    campuses: {
      para1: 'Please add your church campus locations.',
      para2: 'If you only have one location please leave the name as is. If you have multiple locations please add the location name after your church name.',
      para3: 'Example: Church Name - Campus Name',
      yourLocations: {
        para1: 'Please Add A Church Campus',
      },
    },
    dashboardCare: {
      howToSetupYourChurchProfile: {
        para1:
          'On the left hand side, you will see both the church profile and church access menu items. It is important to set up your Church Member login information as this is different from your Church’s Dashboard. You will need to create a username for your church members. You will want to use your church contact email or another dedicated email address for this purpose. Also you will create a password and again choose something easy for them, such as 123TLC or Counseling.',
      },
      howToDirectChurchMembersToTruelifeCare: {
        para1:
          'To direct your church members to TrueLifeCare.org, please use the bulletin inserts or projector images provided in your Church’s Dashboard. Make sure you include your church members login information that you created. On your launch service, use the video provided for your church members to watch. Continue to direct your church members to use this resource by highlighting this option on your church’s website, Facebook page, announcements, Bible Studies, and in your sermons.',
      },
      whyYouShouldIncludeAPersonalVideoFromThePastor: {
        para1:
          'Having a personal video from your pastor helps your members feel accepted, loved, and understood by your church. Mental health tends to be a subject that is avoided by most church members, but this video can break that stigma for your church.',
      },
      howToUseTruelifeCareInCounselingSessions: {
        para1: `TrueLifeCare.org is built for you to use these resources in your counseling sessions. Some pastors have used the videos before ever having a counseling session with an individual. Usually
        when a church member says they want to talk with the pastor, they have a certain topic. If you know what topic that is, you can direct them to watch a certain video on TLC and then have them reconnect with you. Sometimes the questions are already answered in the video and they won’t need to keep their appointment. Other times, having them watch a video allows for the “teaching” about a certain topic to be completed so you can go to the application of a strategy to help the individual. Another option is, after the first session, you can also use a TrueLifeCare.org video as homework for your next session. If there is a particular issue that you believe will help your church member, you can have them review the video and discuss it with you at the beginning of your next session. Furthermore, if you suspect a particular issue that a person is struggling with, but you are not sure, you can have them review a video to see if that sounds like something they struggle with currently. There are many ways to use the videos and other resources to help your church members have a more healthy and spiritually firm life.`,
      },
      evangelismProgram: {
        para1: 'Click To learn more about TrueLife.org Evangelism',
      },
    },
    churchAccess: {
      churchMembersAccessCredentials: {
        para1: 'Setup the login details you will share with your church members. We recommend making the email a general church email, or one for counseling specifically.',
      },
    },
    account: {
      churchMembershipInformation: {
        para1: 'Next Account Renewal Date',
      },
    },
    support: {
      submitASupportRequest: {
        para1: 'Fill out the form on this page to request support from our customer service team.',
      },
    },
    updateBilling: {
      para1: 'Your Account Has An Open Invoice, Please Update Your Card Details',
    },
    welcomeVideo: {
      step1: 'Record Your Welcome Video',
      step2: 'Pick Your Custom URL',
      step3: 'Confirmation!',
      step4: "Now it's time to connect your church!",
    },
    shareYourStory: {
      step1: 'Record Your Story',
      step2: 'Pick Your Custom URL',
      step3: 'Confirmation!',
      step4: "Now it's time to connect your church!",
    },
  },
  cardTitle: {
    yourTestimonials: 'Your Testimonials',
    shareYourStory: 'Share Your Story',
    welcomeVideo: 'Pastor Welcome Video',
    accountPaymentDate: 'Account Payment Date',
    memberDashboardIntro: 'Member Dashboard Introduction',
    churchTraningVideo: 'Invitation Card Training Video',
    videoShareWithChuch: 'Introduction to ShareTheTruthNOW.com',
    jesusStoryChurchPayingVideo: 'Bonus: Invitation Card Training Video',
    whyYouShouldUpgrade: 'Why You Should Upgrade!',
    getMostFromTruelife: 'Easily Use and Set Up You Church’s Jesus Stories',
    getWeeklyResults: 'Get Weekly Results',
    recentUpdate: 'Recent Update',
    howToEditChurchProfile: 'How to Edit Church Profile',
    editYourChurchProfile: 'Edit Your Church Profile',
    editChurchProfile: 'Edit Church Profile',
    howToOrderCards: 'How To Order Cards',
    cardOrderForm: 'Card Order Form',
    instructionsResources: 'Instructions & Resources',
    reOrderingInstructions: 'Re-Ordering Instructions',
    messageFromTruelifeVisitor: 'Messages From TrueLife.org Visitors To Your Church',
    trackYourProgress: 'Track Your Progress',
    submitTrackYourProgress: 'Submit a Track Your Progress',
    studyGuides: 'Study Guides',
    bulletinInserts: 'Bulletin Inserts',
    howToUseThisWizard: 'How To Use This Wizard',
    videoPlayerForYourChurchWebsite: 'Video Player For Your Church Website',
    categorySpecificPlayers: 'Category Specific Players',
    embedThisCodeInYourwebsite: 'Embed this code in your website',
    previewVideoPlayer: 'Preview Video Player',
    howToAddChurchLocation: 'How To Add Church Location',
    yourLocations: 'Your locations',
    locations: 'Locations',
    addYourChurchLocation: 'Add Your Church Location',
    howToSetupYourChurchProfile: 'Dashboard Introduction Video',
    setupShareYourStory: 'Invite Your Church to the Jesus Story Challenge!',
    uploadProfileVideo: 'Upload Profile Video',
    howToDirectChurchMembersToTruelifeCare: 'How to direct church members to TruelifeCare',
    whyYouShouldIncludeAPersonalVideoFromThePastor: 'Why you should include a personal video from the pastor',
    howToUseTruelifeCareInCounselingSessions: 'How to use Truelife Care in counseling sessions',
    evangelismProgram: 'Evangelism Program',
    updateChurchProfile: 'Update Church Profile',
    churchMembersAccessCredentials: 'Church Members Access Credentials',
    churchMembershipInformation: 'Church Membership Information',
    invoices: 'Invoices',
    transactions: 'Transactions',
    updateBillingInfo: 'Payment Information',
    supportRequest: 'Support Request',
    submitASupportRequest: 'Submit a Support Request',
    specificCategoryEmbed: 'Specific Category Embed',
    churchLocation: {
      adminUpdate: 'Update Church Location',
      adminAdd: 'Add Church Location',
      update: 'Update Your Church Location',
      add: 'Add Your Church Location',
    },
    socialMedia: 'Social Media',
    mediaResources: 'Media Resources',
    updateYourProfile: 'Update your profile',
    settings: 'Settings',
    // connectToChurch: "Now it's Time to Connect Your Church!",
    connectToChurch: 'Last Challenge Step: Connect Your Church!',
  },
  button: {
    clear: 'Clear',
    download: 'Download',
    video: 'Video',
    downloadTrainngVideo: 'Download Video',
    updateAccount: 'Update account',
    copyToClipboard: 'Copy to clipboard',
    back: 'Back',
    nextSelectCategories: 'Next: Select Categories',
    nextGenerateEmbedCode: 'Next: Generate Embed Code',
    createLocation: 'Create Location',
    learnMore: 'Learn More',
    updateSettings: 'Update Settings',
    updateProfile: 'Update Profile',
    updateUser: 'Update User',
    createUser: 'Create User',
    updateAnswer: 'Update Answer',
    createAnswer: 'Create Answer',
    updateCategory: 'Update Category',
    createCategory: 'Create Category',
    updateSpeakerBio: 'Update Speaker Bio',
    createSpeakerBio: 'Create Speaker Bio',
    updateLocation: 'Update Location',
    createSpecificCategoryEmbed: 'Create Specific Category Embed',
    save: 'Save',
    submit: 'Submit',
    giveNow: 'Give now',
    upload: 'Upload',
    cancel: 'Cancel',
    continue: 'Continue',
    socialMediaKit: 'Social Media Kit',
    mediaPackage: 'Media Package',
    resetMyPassword: 'Reset my password',
    goBack: ' Go Back',
    login: 'Log In',
    signUp: 'Sign Up',
    yes: 'Yes',
    no: 'No',
    edit: 'Edit',
    delete: 'Delete',
    search: 'Search',
    reset: 'Reset',
    hidePreview: 'Hide Preview',
    preview: 'Preview',
    accountDetails: 'Account Details',
    downloadCheatSheet: 'Download CheatSheet',
    readyToGo: 'Get Started!',
    startOver: 'Start Over',
    uploadVideo: 'Upload Video',
    recordVideo: 'Record Video',
    embedVideo: 'Embed Video',
    redo: 'Redo',
    keep: 'Keep',
    redoAll: 'Redo All',
    keepAll: 'Save All',
    redoTypeVideo: 'Redo {type} Video',
    takeThumbnail: 'Select the video thumbnail from the video',
  },
  label: {
    churchDescription: 'Church Description',
    videoEmbed: 'Video Embed',
    serviceTimes: 'Service Times',
    contactDetails: 'Contact Details',
    website: 'Website',
    useWebsite: 'Use Profile Website',
    phone: 'Phone Number',
    facebook: 'Facebook',
    twitter: 'Twitter',
    profileBannerPicture: 'Profile Banner Picture',
    pastorsHeadshot: 'Pastors Headshot',
    viewMessage: 'View Message',
    subject: 'Subject',
    from: 'From',
    yourDonationPageAddress: 'Your Donation Page Address',
    createSpecificCategoryEmbed: 'Create Specific Category Embed',
    embedThisCodeInYourWebsite: 'Embed this code in your website',
    name: 'Name',
    address: 'Address',
    address2: 'Address 2',
    city: 'City',
    state: 'State',
    zipCode: 'Zip code',
    country: 'Country',
    counselingPastor: 'Counseling Pastor',
    counselingContactEmail: 'Counseling Contact Email',
    churchAddress: 'Church Address',
    churchPhone: 'Church Phone',
    churchWebsite: 'Church Website',
    welcomeVideoEmbedCode: 'Welcome Video - Embed Code',
    email: 'Email',
    password: 'Password',
    newPassword: 'New password',
    churchLoginDetail: 'Church Login Detail',
    careLogin: 'Care login',
    carePassword: 'Care password',
    invoiceID: 'Invoice ID',
    total: 'Total',
    download: 'Download',
    downloadPDF: 'Download PDF',
    status: 'Status',
    action: 'Action',
    amount: 'Amount',
    date: 'Date',
    invoice: 'Invoice',
    description: 'Description',
    firstNameFirstHalfChurchName: 'First Name (Or First Half Church Name)',
    lastNameSecondHalfChurchName: 'Last Name (Or Second Half Church Name)',
    cardNumber: 'Card Number',
    expirationDate: 'Expiration Date',
    CVV: 'CVV',
    pastorFirstName: 'Pastor First Name',
    pastorLastName: 'Pastor Last Name',
    role: 'Role',
    cellPhone: 'Cell Phone',
    churchName: 'Church Name',
    planInformation: 'Plan Information',
    plan: 'Plan',
    price: 'Price',
    errorAccountPlanInvalid: 'Account and Plan invalid',
    errorAccountInvalid: 'Account invalid',
    errorPlanInvalid: 'Plan invalid',
    selectFomGallery: 'Select cover image from gallery',
    uploading: 'Uploading',
    nextBillingDate: 'Next billing date',
    contactSupport: 'Contact Support',
    termsOfUse: 'Terms of Use',
    support: 'Support',
    contacts: 'Contacts',
    areYouSure: 'Are you sure?',
    firstName: 'First Name',
    lastName: 'Last Name',
    search: 'Search',
    embedVideoUrl: 'Embed Video URL:',
    pickCustomUrl: 'Pick Your Custom URL:',
    truelifeTypePage: 'Truelife {type} Page:',
    directConnectionLink: 'Pastor Invitation Link:',
    inviteModerator: 'Invite Moderators',
    moderatorInvitationLink: 'Moderator Invitation Link:',
    somethingWentWrong: 'Something went wrong!',
    slugExists: 'This Custom URL already exists, please pick another one.',
    jesusStories: 'Jesus story videos:',
    qrCode: 'QR Code',
    introVideoStatus: {
      created: 'Under Review',
      review: 'Under Review',
      approved: 'Approved',
      blocked: 'Blocked',
      no_payment: 'No Payment',
    },
    supportEmail: 'Support Email',
    designerEmail: 'Designer Email',
    welcomeInstructionLink: 'Welcome Instruction Link(P)',
    shareStoryInstructionLink: 'Jesus Story Instruction Link(i)',
    mainDashboardVideoLink_p: 'Main Dashboard Video(P)',
    mainDashboardVideoLink_i: 'Mani Dashboard Video(i)',
    evangelismBootCampLink_p: 'Evangelism Boot Camp Video(P)',
    evangelismBootCampLink_i: 'Evangelism Boot Camp Video(i)',
    moderatorVideoLink: 'Moderator Video',
    individualSignupLink: 'Individual Signup',
    reminderStoryLink: 'Pop up reminder for story',
    reminderWelcomeLink: 'Pop up reminder for welcome',
    churchInvitationLink: 'Pastor Invitation Video',
    churchModeratorInvitationLink: 'Moderator Invitation Video',
  },
  placeholder: {
    pleaseInputTheLocationName: 'Please input the location name!',
    pleaseInputYourAddress: 'Please input your address!',
    pleaseInputYourCity: 'Please input your city!',
    pleaseInputYourState: 'Please input your state!',
    pleaseInputYourZipcode: 'Please input your zipcode!',
    pleaseInputYourCountry: 'Please input your country!',
    yourChurchWebsiteAddress: 'Your Church Website Address',
    yourDonationPageAddress: 'Your Donation Page Address',
    pleaseInputPastorFirstName: 'Please input Pastor First Name!',
    pleaseInputPastorLastName: 'Please input Pastor Last Name!',
    pleaseInputRole: 'Please input your role!',
    pleaseInputCellPhone: 'Please input your cell phone!',
    pleaseInputChurchName: 'Please input your church name!',
    pleaseInputEmail: 'Please input your email!',
    pleaseInputPassword: 'Please input your password!',
    pleaseInputCarePastor: 'Please input Care Pastor!',
    pleaseInputCareEmail: 'Please input Care Email!',
    pleaseInputCareAddress: 'Please input Care Address!',
    pleaseInputCarePhone: 'Please input Care Phone!',
    pleaseInputCareWebsite: 'Please input Care Website!',
    pleaseInputFirstName: 'Please input First Name!',
    pleaseInputLastName: 'Please input Last Name!',
    pleaseInputCardNumber: 'Please input Card Number!',
    pleaseInputMonth: 'Please input Month!',
    pleaseInputYear: 'Please input Year!',
    pleaseInputCVV: 'Please input CVV!',
    pleaseInputAddress: 'Please input address!',
    pleaseInputState: 'Please input state!',
    pleaseInputCity: 'Please input city!',
    pleaseInputCountry: 'Please input country!',
    pleaseInputChurchDescription: 'Please input Church Description!',
    pleaseInputContactDetails: 'Please input Contact Details!',
    pleaseInputTitle: 'Please input title!',
    pleaseInputSlug: 'Please input slug!',
    pleaseInputDescription: 'Please input description!',
    pleaseSelectAnswerType: 'Please select Answer Type!',
  },
};

export default {
  locale: 'en',
  localeAntd,
  messages,
};
